import { Alert, Col, Row, Tag, Typography } from "antd"
import { QuoteStateLabels } from "containers/quotes/constants"
import { IQuoteReferralReason } from "platform-client/types/quote"

const { Text } = Typography

interface IQuoteReferredAlertProps {
  isReferred?: boolean
  referralReasons?: IQuoteReferralReason[]
}

export const QuoteReferredAlert: React.FC<IQuoteReferredAlertProps> = (
  props
) => {
  return props.isReferred ? (
    <Alert
      banner
      type="warning"
      style={{ marginBottom: 20 }}
      closable={true}
      closeText="Hide"
      description={
        <Row>
          <Col flex="80px">
            <Tag color={QuoteStateLabels["Referred"].color}>
              {QuoteStateLabels["Referred"].label.toUpperCase()}
            </Tag>
          </Col>
          <Col flex="auto">
            {(props.referralReasons || []).length ? (
              <>
                <Text>This quote was referred with the following reasons:</Text>
                <ul>
                  {(props.referralReasons || []).map((item) => (
                    <li>{item.text}</li>
                  ))}
                </ul>
              </>
            ) : (
              <Text>This quote was referred</Text>
            )}
          </Col>
        </Row>
      }
    />
  ) : null
}
